import router from '@/router'
import { storeApp } from '@/store'
import { http } from '@/http'

// const PATH = 'auth/'
const PATH = ''

class AuthService {
  async login (request) {
    return http.post(PATH.concat('login'), request)
  }

  async logout () {
    await http.post(PATH.concat('logout'))
    storeApp.state.accessToken.clear()

    return router.push('/login')
  }
}

export default new AuthService()
